import { FC, PropsWithChildren } from 'react'

/** Props for the shared page/section title component. */
type PageTitleProps = PropsWithChildren<{
  as?: 'h1' | 'h2' | 'h3'
  className?: string
}>

/**
 * Typographic title component with sensible defaults for hierarchy.
 * Use `as` to change the semantic heading level.
 */
export const PageTitle: FC<PageTitleProps> = ({ as = 'h1', className, children }) => {
  const Tag = as
  const sizeClass =
    as === 'h1' ? 'text-3xl sm:text-4xl' : as === 'h2' ? 'text-2xl' : 'text-xl'
  const classes = ['font-display text-brand-blue', sizeClass, className].filter(Boolean).join(' ')

  return <Tag className={classes}>{children}</Tag>
}
